import React, { useState, useEffect } from "react";

const OrganizationForm = ({
  addOrganization,
  updateOrganization,
  selectedOrganization,
  setActiveView,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
  });

  useEffect(() => {
    if (selectedOrganization) {
      setFormData({
        name: selectedOrganization.name,
        address: selectedOrganization.address,
        phone: selectedOrganization.phone,
        email: selectedOrganization.email,
      });
    }
  }, [selectedOrganization]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (selectedOrganization) {
      updateOrganization({
        ...selectedOrganization,
        ...formData,
      });
    } else {
      addOrganization(formData);
    }
  };

  return (
    <div className="form-container">
      <h2>
        <span>{selectedOrganization ? "✏️" : "➕"}</span>
        {selectedOrganization ? "Edit organization" : "Add new organization"}
      </h2>

      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="name">Organization name *</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-input"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter organization name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone number *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              className="form-input"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+374XXXXXXXX"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="email@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">Address *</label>
            <input
              type="text"
              id="address"
              name="address"
              className="form-input"
              value={formData.address}
              onChange={handleChange}
              required
              placeholder="Enter address"
            />
          </div>
        </div>

        <div className="form-buttons">
          <button
            type="button"
            className="cancel-btn"
            onClick={() => setActiveView("organizations")}
          >
            Cancel
          </button>
          <button type="submit" className="submit-btn">
            {selectedOrganization ? "Save changes" : "Add organization"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default OrganizationForm;
